module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "boxs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" 找回密码 ")]), _vm._v(" "), _c('div', {
    staticClass: "boxskuang"
  }, [_c('div', {
    staticClass: "input-box m-b-10",
    class: {
      error: !!_vm.phoneError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "captcha flex flex-between m-b-10"
  }, [_c('div', {
    staticClass: "input-box",
    class: {
      error: !!_vm.captchaError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captcha),
      expression: "captcha"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "captcha-img m-l-10",
    on: {
      "click": function($event) {
        _vm.captchasrc = '/wapi/base/captcha?' + (new Date).getTime()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captchasrc
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-box reg-ms flex",
    class: {
      error: !!_vm.verifyError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ms-text flex-shrink",
    on: {
      "click": _vm.onSend
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.time >= 0 ? '还剩 ' + _vm.time + ' 秒' : '发送验证码') + "\r\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "tips",
    class: {
      error: _vm.phoneError || _vm.captchaError || _vm.verifyError
    }
  }, [_vm._v(_vm._s(_vm.phoneError || _vm.captchaError || _vm.verifyError))]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a60f78a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/mmzhStepone.vue
// module id = 902
// module chunks = 1